import * as actions from './retention-actions';
import { state } from './retention-state';

export const retention = {
  state,
  actions,
};
